module.exports = __webpack_public_path__ + "img/80m1.170624b6.jpg";